import { createContext, useContext, useState } from 'react';

import ScheduleModal from '../components/crm/opportunity/schedule/crm.opportunity.schedule.modal';
import ScheduleConclusionModal from '../components/crm/opportunity/schedule/crm.opportunity.schedule.conclusion.modal';

const ScheduleContext = createContext({
    openScheduleModal: () => {},
    openScheduleConclusionModal: () => {},
});

export const useScheduleModals = () => useContext(ScheduleContext);

export const ScheduleProvider = ({ children }) => {

    const [scheduleRequest, setScheduleRequest] = useState(null);
    const [conclusionRequest, setConclusionRequest] = useState(null);

    const openScheduleModal = ({ opportunity, activityId = null, origin = null, onScheduled }) =>
        setScheduleRequest({ opportunity, activityId, origin, onScheduled });

    const openScheduleConclusionModal = ({ opportunity, activity, prefillMessage = '', origin = null, onConcluded, onCancel }) =>
        setConclusionRequest({ opportunity, activity, prefillMessage, origin, onConcluded, onCancel });

    const finishSchedule = (result) => {
        const request = scheduleRequest;
        setScheduleRequest(null);
        request?.onScheduled && request.onScheduled(result);
    };

    const finishConclusion = (result) => {
        const request = conclusionRequest;
        setConclusionRequest(null);
        request?.onConcluded && request.onConcluded(result);
    };

    const cancelConclusion = () => {
        const request = conclusionRequest;
        setConclusionRequest(null);
        request?.onCancel && request.onCancel();
    };

    return (
        <ScheduleContext.Provider value={{ openScheduleModal, openScheduleConclusionModal }}>
            {children}

            {scheduleRequest && (
                <ScheduleModal
                    isOpen
                    opportunity={scheduleRequest.opportunity}
                    activityId={scheduleRequest.activityId}
                    origin={scheduleRequest.origin}
                    onClose={() => setScheduleRequest(null)}
                    onScheduled={finishSchedule}
                />
            )}

            {conclusionRequest && (
                <ScheduleConclusionModal
                    isOpen
                    opportunity={conclusionRequest.opportunity}
                    prefillMessage={conclusionRequest.prefillMessage}
                    origin={conclusionRequest.origin}
                    onClose={cancelConclusion}
                    onConcluded={finishConclusion}
                />
            )}
        </ScheduleContext.Provider>
    );
};
